import React from 'react';
import Button from '@react/react-spectrum/Button';
import { connect } from 'react-redux';
import { ADOBE_CHANNEL_PARTNER, CONTACT_HELPDESK } from '../../config/constants';
import { upsertAccount, rtrnSaveNExt, onSaveNExt, upsertContact, upsertAnswers, updateLevel, updateQuestionnaire2,validateContacts ,uplevelRenew } from './CommonButtonsActions';
import { getFormValues } from 'redux-form';
import { saveAndExitUpdate } from '../../storeManagement/action';
import { setLocaleWithFallback } from '../../../actions';
import { isSavingToggle } from '../../../actions/commonActions';
import { Translate } from 'react-redux-i18n';

const createButton = (prop) => {
    const allbuttonFunc = addFunctions(prop.allbuttonFunc, prop);
    return getButtons(prop.btn, allbuttonFunc, prop.isValidated, prop);
}

function getButtons(btns, allbuttonFunc, isValidated, prop){
    let finalBtns = [];
    btns.forEach((btn) => {
        let propToButton = {};
        if(btn.btnProp) {
            btn.btnProp.forEach((propName) => {
                if(propName === 'prop') {
                    propToButton = {...prop};
                }
                propToButton.btnLabel = btn.btnLabel;
            });
        }
        finalBtns.push(<Button variant={btn.btnVariant} 
                                // TO BE UPDATED back
                                key={btn.key ? btn.key : btn.btnLabel + Math.random()}
                                disabled={btn.btnToValidate ? isValidated : false}
                                // disabled={false}
                                onMouseDown={() => allbuttonFunc[btn.btnFunc] !== undefined ? 
                                                allbuttonFunc[btn.btnFunc](
                                                    propToButton ? propToButton : ""
                                                ) : 
                                                {}}>
                             <Translate value={'uplevelRenewal.' + btn.btnLabel} />
                        </Button>)
    });
    return finalBtns;
}

// btnFunc : onNextButton
const mapStateToProps = (state) => ({
    currentStage: state.uplevelRenewal.currentStage,
    isSaving: state.common.isSaving,
    isValidated: state.uplevelRenewal.isValidated,
    formStates: getFormValues('uplevelRenewal')(state)
  });

const mapDispatchToProps = (dispatch) => ({
    onClkSaveAndExit: (bool) => dispatch(saveAndExitUpdate(bool)),
    is_saving: (e) => dispatch(isSavingToggle(e))
  });

export const MakeButton = connect(mapStateToProps, mapDispatchToProps)(createButton);



// outer array for Different pages
// inner array is for Buttons like previous, next, etc
//Buttons for Uplevel
export const ButtonMap =
[
    [
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnFunc : 'updateLevel',
            btnProp : ['prop'],
            btnToValidate : true
        }
    ],
    [
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnFunc : 'onNextButton',
            btnToValidate : true
        }
    ],
    [
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnFunc : 'upsertAccount',
            btnProp : ['prop'],
            btnToValidate : true
        }
    ],
    [
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnFunc : 'validateContacts',
            btnProp : ['prop'],
            btnToValidate : true
        }
    ],
    [
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Save and Exit',
            btnVariant : 'primary',
            btnToValidate : true,
            btnFunc : 'upsertAnswers',
            btnProp : ['prop']
        },
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnToValidate : true,
            btnFunc : 'upsertAnswers',
            btnProp : ['prop'],
        }
    ],
    [
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Save and Exit',
            btnVariant : 'primary',
            btnToValidate : true,
            btnFunc : 'updateQuestionnaire2',
            btnProp : ['prop']
        },
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnToValidate : true,
            btnFunc : 'updateQuestionnaire2',
            btnProp : ['prop']
        }
    ],
    [   {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Submit',
            btnVariant : 'cta',
            btnFunc : 'uplevelRenew',
            btnToValidate : true,
            btnProp : ['prop']
        }
    ],
    [
        {
            btnLabel : 'Contact Helpdesk',
            btnVariant : 'primary',
            btnFunc : 'openHelpDesk'
        }
    ],
    [
        {
            btnLabel : 'Continue Enrollment',
            btnVariant : 'primary',
            btnFunc : 'rtrnSaveNExt'
        }
    ],
]

//Buttons for Renewal
export const ButtonMapRenewal =
[
    [
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnFunc : 'onNextButton',
            btnToValidate : true
        }
    ],
    [
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnFunc : 'upsertAccount',
            btnProp : ['prop'],
            btnToValidate : true
        }
    ],
    [
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnFunc : 'validateContacts',
            btnProp : ['prop'],
            btnToValidate : true
        }
    ],
    [
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Save and Exit',
            btnVariant : 'primary',
            btnToValidate : true,
            btnFunc : 'upsertAnswers',
            btnProp : ['prop']
        },
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnToValidate : true,
            btnFunc : 'upsertAnswers',
            btnProp : ['prop'],
        }
    ],
    [
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Save and Exit',
            btnVariant : 'primary',
            btnToValidate : true,
            btnFunc : 'updateQuestionnaire2',
            btnProp : ['prop']
        },
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnToValidate : true,
            btnFunc : 'updateQuestionnaire2',
            btnProp : ['prop']
        }
    ],
    [   {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Submit',
            btnVariant : 'cta',
            btnFunc : 'uplevelRenew',
            btnToValidate : true,
            btnProp : ['prop']
        }
    ],
    [
        {
            btnLabel : 'Contact Helpdesk',
            btnVariant : 'primary',
            btnFunc : 'openHelpDesk'
        }
    ],
    [
        {
            btnLabel : 'Continue Enrollment',
            btnVariant : 'primary',
            btnFunc : 'rtrnSaveNExt'
        }
    ],
]

//Buttons for Renewal Registered
export const ButtonMapRenewalRegistered =
[
    [
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnFunc : 'onNextButton',
            btnToValidate : true
        }
    ],
    [
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnFunc : 'upsertAccount',
            btnProp : ['prop'],
            btnToValidate : true
        }
    ],
    [
        {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnFunc : 'validateContacts',
            btnProp : ['prop'],
            // btnFunc : 'onNextButton',
            btnToValidate : false
        }
    ],
    [   {
            btnLabel : 'Previous',
            btnVariant : 'primary',
            btnFunc : 'onPreviousButton'
        },
        {
            btnLabel : 'Submit',
            btnVariant : 'cta',
            btnFunc : 'uplevelRenew',
            btnToValidate : true,
            btnProp : ['prop']
        }
    ],
    [
        {
            btnLabel : 'Contact Helpdesk',
            btnVariant : 'primary',
            btnFunc : 'openHelpDesk'
        }
    ],
    [
        {
            btnLabel : 'Continue Enrollment',
            btnVariant : 'primary',
            btnFunc : 'rtrnSaveNExt'
        }
    ]
]

//Buttons for demand
// [0] - make membership call if renewal draft is not present.
export const ButtonsOnDemand =
[
    [
        {
            btnLabel : 'Next',
            btnVariant : 'cta',
            btnFunc : 'updateLevel',
            btnProp : ['prop'],
            btnToValidate : true
        }
    ],
]

const addFunctions = (allbuttonFunc, onClkSaveAndExit) => {
    allbuttonFunc.upsertContact = upsertContact;
    allbuttonFunc.openChannelPartner = openChannelPartner;
    allbuttonFunc.openHelpDesk = openHelpDesk;
    allbuttonFunc.upsertAccount = upsertAccount;
    allbuttonFunc.rtrnSaveNExt = rtrnSaveNExt;
    allbuttonFunc.onSaveNExt = onSaveNExt;
    allbuttonFunc.upsertAnswers = upsertAnswers;
    allbuttonFunc.updateLevel = updateLevel;
    allbuttonFunc.updateQuestionnaire2 = updateQuestionnaire2;
    allbuttonFunc.validateContacts = validateContacts;
    allbuttonFunc.uplevelRenew = uplevelRenew;
    return allbuttonFunc;
}

const openChannelPartner = (newTab=true) => {
    if(newTab){
    window.open(window.apcConfig.partner.home, "_blank");
    }
    else{
        window.open(window.apcConfig.partner.home,"_self");
    }
}
const openHelpDesk = () => {
    window.open(CONTACT_HELPDESK, "_blank");
}